import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var HistorySvg = function HistorySvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.928 17.625q-3.57 0-6.061-2.528T.375 8.976h1.438q0 2.996 2.06 5.103 2.061 2.108 5.055 2.108 3.044 0 5.151-2.132 2.108-2.131 2.108-5.175 0-2.97-2.132-5.02-2.131-2.047-5.127-2.047a6.5 6.5 0 0 0-3.055.742 8.3 8.3 0 0 0-2.48 1.965H5.91v1.437H.902V.974H2.34v2.54a9.1 9.1 0 0 1 2.958-2.3 8.15 8.15 0 0 1 3.63-.839q1.797 0 3.378.67a8.9 8.9 0 0 1 2.767 1.834 8.6 8.6 0 0 1 1.87 2.719 8.3 8.3 0 0 1 .682 3.354 8.4 8.4 0 0 1-.683 3.378 8.7 8.7 0 0 1-1.869 2.755 8.9 8.9 0 0 1-2.767 1.857 8.4 8.4 0 0 1-3.378.683m3.067-4.72-3.69-3.641V4.136h1.438v4.529l3.282 3.21z"
  }));
};
export var History = function History(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: HistorySvg
  }));
};